import { render } from "./Top4StatsCard.vue?vue&type=template&id=4c9a8734&ts=true"
import script from "./Top4StatsCard.vue?vue&type=script&lang=ts"
export * from "./Top4StatsCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\map-web-lechan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__